import { Box, Button, Typography } from '@mui/material'
import { useContext } from 'react'

import {
  DrinkCounterContext,
  DrinkCounterContextInterface,
} from '../../../providers/DrinkCounter/DrinkCounterProvider'
import {
  MUMContext,
  MUMContextInterface,
} from '../../../providers/MUM/MUMProvider'
import {
  BACContext,
  BACContextInterface,
} from '../../../providers/PatientChartPage/BACProvider'
import { themeColors } from '../../../theme'
import { Modal } from '../../Modal/Modal'
import { useStyles } from '../PatientChartPage.styles'

interface ReviewBacOrDrinkTypesModalInterface {
  routedPatientId: string | undefined
  selectedReviewOption: string
  recordId?: number
  showReviewModal: boolean
  setShowReviewModal: React.Dispatch<React.SetStateAction<boolean>>
  setFilteredDataWithVideos?: React.Dispatch<React.SetStateAction<any[]>> | null
}

export const ReviewBacOrDrinkTypesModal = ({
  routedPatientId,
  selectedReviewOption,
  recordId,
  showReviewModal,
  setShowReviewModal,
  setFilteredDataWithVideos,
}: ReviewBacOrDrinkTypesModalInterface) => {
  const { classes } = useStyles()

  const { getPatientMUMRecords, reviewMumRecord } = useContext(
    MUMContext
  ) as MUMContextInterface

  const { getBacRecords, reviewBacRecord } = useContext(
    BACContext
  ) as BACContextInterface

  const { getPatientDrinkTypes, resetPatientDrinkTypes } = useContext(
    DrinkCounterContext
  ) as DrinkCounterContextInterface

  return (
    <Modal
      open={showReviewModal}
      setOpen={setShowReviewModal}
      title={
        selectedReviewOption === 'Review BAC' ||
        selectedReviewOption === 'Review MUM'
          ? 'Mark as Reviewed'
          : 'Reset Drink Types'
      }
      width={'30%'}
      ModalContent={
        <Box
          sx={{
            width: '92%',
            margin: 'auto',
            padding: '10px 0',
          }}
        >
          <Typography
            sx={{
              fontSize: '20px',
              lineHeight: '25px',
              color: themeColors.grayblack,
              padding: '10px 0',
            }}
          >
            {selectedReviewOption === 'Review BAC' ||
            selectedReviewOption === 'Review MUM'
              ? 'Are you sure you want to mark this video as reviewed?'
              : 'Are you sure to reset drink types for this patient?'}
          </Typography>
          <div className={classes.modalBtnWrapper}>
            <Button
              onClick={async () => {
                if (
                  selectedReviewOption === 'Review BAC' &&
                  recordId &&
                  setFilteredDataWithVideos
                ) {
                  await reviewBacRecord(recordId)
                  if (routedPatientId) {
                    const newData = await getBacRecords(Number(routedPatientId))
                    setShowReviewModal(false)
                    setFilteredDataWithVideos(newData)
                  }
                }
                if (
                  selectedReviewOption === 'Review Drink Types' &&
                  routedPatientId
                ) {
                  await resetPatientDrinkTypes(parseInt(routedPatientId))
                  await getPatientDrinkTypes(parseInt(routedPatientId))
                  setShowReviewModal(false)
                }
                if (
                  selectedReviewOption === 'Review MUM' &&
                  recordId &&
                  setFilteredDataWithVideos
                ) {
                  await reviewMumRecord(recordId)
                  if (routedPatientId) {
                    const newData = await getPatientMUMRecords(
                      Number(routedPatientId)
                    )
                    setShowReviewModal(false)
                    setFilteredDataWithVideos(newData)
                  }
                }
              }}
              variant='contained'
              style={{
                fontSize: '16px',
                marginTop: '10px',
                width: '180px',
                backgroundColor: themeColors.red,
                borderColor: 'transparent',
              }}
            >
              {selectedReviewOption === 'Review BAC' ||
              selectedReviewOption === 'Review MUM'
                ? 'Mark as Reviewed'
                : 'Reset Drink Types'}
            </Button>
            <Button
              onClick={() => {
                setShowReviewModal(false)
              }}
              variant='contained'
              style={{
                fontSize: '16px',
                marginTop: '10px',
                width: '80px',
              }}
            >
              Cancel
            </Button>
          </div>
        </Box>
      }
    />
  )
}
